import React from 'react';
import SingleValue from '@splunk/dashboard-visualizations/SingleValue';

export default () => (
    <SingleValue
        options={{
            sparklineAreaGraph: true,
        }}
        encoding={{
            trend: 'primary.foo',
        }}
        dataSources={{
            primary: {
                data: {
                    columns: [
                        ['1', '62', '103', '308', '587', '876', '930', '1320'],
                        [
                            '2018-08-19T00:00:00.000+00:00',
                            '2018-08-20T00:00:00.000+00:00',
                            '2018-08-21T00:00:00.000+00:00',
                            '2018-08-22T00:00:00.000+00:00',
                            '2018-08-23T00:00:00.000+00:00',
                            '2018-08-24T00:00:00.000+00:00',
                            '2018-08-25T00:00:00.000+00:00',
                            '2018-08-26T00:00:00.000+00:00',
                        ],
                    ],
                    fields: [
                        {
                            name: 'foo',
                        },
                        {
                            name: '_time',
                        },
                    ],
                },
                meta: {},
            },
        }}
    />
);
